import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Email } from "model";

export default class Profile extends BCMSRecord {
    _agreedToDiscovery;
    _city;
    _street;
    _state;
    _zip;
    _phone;

    constructor(record) {
        super(record);
    }
}

Profile.define({
    "recordType": "profile",
    "recordIDProp": "",
    "className" : "Profile",
    "recordProperties": [
        BCMSRecordProperty.mapToBoolean("agreedToDiscovery", "_agreedToDiscovery"),
        BCMSRecordProperty.mapToString("name", "_name"),
        BCMSRecordProperty.mapToString("city", "_city"),
        BCMSRecordProperty.mapToString("street", "_street"),
        BCMSRecordProperty.mapToString("state", "_state"),
        BCMSRecordProperty.mapToString("zip", "_zip"),
        BCMSRecordProperty.mapToString("phone", "_phone"),
        BCMSRecordProperty.mapToClass("email", "_email", () => Email),
        BCMSRecordProperty.mapToBoolean("hasBillerGroupsOn", "_hasBillerGroupsOn"),
    ]
});